import { DedicatedPreorder, DedicatedPreorderStatus } from '../../../api/dedicatedPreordersService'
import { extractErrorMessage } from '../../../utils/error-extractor'

export const preordersPath = '/dedicated-servers/preorders'
export const preorderStatuses: DedicatedPreorderStatus[] = ['submitted', 'provisioning', 'released', 'cancelled']
export const quickPreorderStatuses: DedicatedPreorderStatus[] = ['submitted', 'provisioning', 'released', 'cancelled']
export const preorderStatusKey = (status: string) => `PREORDERS_${status.toUpperCase()}`
export const canReleasePreorder = (preorder: DedicatedPreorder) => (
  !preorder.issued_server && ['submitted', 'provisioning'].includes(preorder.status)
)
export const preorderError = (error: any, fallback: string) => extractErrorMessage(error?.response?.data) || fallback

export const diskDescriptions = (preorder: DedicatedPreorder) => {
  const disks = new Map<string, { label: string; count: number }>()
  for (const { disk } of preorder.disks || []) {
    if (!disk) continue
    const current = disks.get(disk.id)
    disks.set(disk.id, { label: `${disk.name || disk.model} · ${disk.size_gb} GB · ${disk.disk_type}`, count: (current?.count || 0) + 1 })
  }
  return [...disks.values()].map(({ label, count }) => `${count} × ${label}`)
}
